export function numberToMoney(x) {
  return (x / 100.0).toFixed(2).replace(".", ",");
}

export function dateFormatBR(x) {
  const date = new Date(x);
  return (
    date.getDate().toString().padStart(2, "0") +
    "/" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    date.getFullYear() +
    " " +
    date.getHours().toString().padStart(2, "0") +
    ":" +
    date.getMinutes().toString().padStart(2, "0")
  );
}

export function dateFormatBRWithoutHour(x) {
  const date = new Date(x);
  return (
    date.getDay().toString().padStart(2, "0") +
    "/" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    date.getFullYear()
  );
}

export function right(str, n) {
  if (n <= 0) return "";
  else if (n > String(str).length) return str;
  else {
    var iLen = String(str).length;
    return String(str).substring(iLen, iLen - n);
  }
}

export function formatCPF(cpf, obfuscate = false) {
  cpf = cpf.replace(/[^\d]/g, "");

  if (obfuscate) {
    // Substituir os 4 primeiros números do CPF por asteriscos
    cpf = cpf.replace(/^(\d{3})\d{3}(\d{3})\d{2}$/, "$1***$2***");
  }

  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export function formatCNPJ(cnpj, obfuscate = false) {
  cnpj = cnpj.replace(/[^\d]/g, ""); // Remove qualquer caractere que não seja número

  if (obfuscate) {
    // Substituir os 6 primeiros números do CNPJ por asteriscos
    cnpj = cnpj.replace(/^(\d{2})\d{3}\d{3}(\d{4})\d{2}$/, "$1***$2***");
  }

  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function formatDocument(cpfCnpj, obfuscate = false) {
  if (cpfCnpj.length === 11) {
    return formatCPF(cpfCnpj, obfuscate);
  } else if (cpfCnpj.length === 14) {
    return formatCNPJ(cpfCnpj, obfuscate);
  }
  return cpfCnpj;
}


export function formatPhone(phone) {
  phone = phone.replace(/[^\d]/g, "");
  return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
}

export function formatTellPhone(phone) {
  phone = phone.replace(/[^\d]/g, "");
  return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
}

export function formatMoneyBRL(value) {
  return (
    "R$ " +
    value
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")
  );
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function formatPlateBR(placa) {
  // Remover todos os caracteres que não são letras ou números
  placa = placa.replace(/[^a-zA-Z0-9]/g, "");

  // Verificar se a placa possui 7 ou 8 caracteres
  if (placa.length !== 7 && placa.length !== 8) {
    return "Placa inválida";
  }

  // Formatando a placa (XXX0X00)
  let placaFormatada =
    placa.slice(0, 3).toUpperCase() +
    "-" +
    placa.slice(3, 7).replace(/([a-zA-Z])/g, "$1") +
    placa.slice(7);

  return placaFormatada;
}

export function isValidYearVehicle(ano) {
  // Verifica se 'ano' é uma string numérica ou um número inteiro positivo
  if (
    (typeof ano !== "string" || !/^\d+$/.test(ano)) &&
    (typeof ano !== "number" || !Number.isInteger(ano) || ano <= 0)
  ) {
    return false;
  }

  // Se 'ano' for uma string, converte para número inteiro
  if (typeof ano === "string") {
    ano = parseInt(ano, 10);
  }
  const anoAtual = new Date().getFullYear();
  const anoMinimo = 1900; // Defina o ano mínimo que deseja aceitar
  const anoMaximo = anoAtual + 1; // Defina o ano máximo permitido (por exemplo, 10 anos no futuro)
  return ano >= anoMinimo && ano <= anoMaximo;
}

export function calcCrow(lat1, lon1, lat2, lon2) {
  var R = 6371; // km
  var dLat = toRad(lat2 - lat1);
  var dLon = toRad(lon2 - lon1);
  var lat1 = toRad(lat1);
  var lat2 = toRad(lat2);

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
}

// Converts numeric degrees to radians
function toRad(Value) {
  return (Value * Math.PI) / 180;
}

export function lastDayMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}

export function formatHour(hour) {
  return hour.toString().padStart(2, "0") + ":" + "0".padStart(2, "0");
}

export function normaliseValue(value, decimals = 2) {
  if (!value) {
    return "";
  }
  if (value === ".") {
    return (value = "0.");
  }

  var regex = new RegExp(`^-?\\d+(?:\\.\\d{0,${decimals}})?`);
  const decimalsNumber = value.toString().match(regex)[0];
  const parsed = parseFloat(decimalsNumber).toFixed(2);
  if (isNaN(parsed)) {
    return "0";
  }
  return parsed;
}

export const DATE_FORMAT_DD_MM_HH_MM = "DD/MM HH:mm";

export function formatDate(dateString, format) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  const hour = date.getHours().toString().padStart(2, '0');
  const minute = date.getMinutes().toString().padStart(2, '0');
  const second = date.getSeconds().toString().padStart(2, '0');

  let result = format.replace('DD', day);
  result = result.replace('MM', month);
  result = result.replace('YYYY', year);
  result = result.replace('HH', hour);
  result = result.replace('mm', minute);
  result = result.replace('ss', second);

  return result;
}
